import { connect } from 'react-redux'
import { setFaqExpandedNodeIds, setFaqScrollToId } from 'redux/actions'
import SmartFcFaqReferenceLink from 'components/SmartFcFaqReferenceLink'

const mapStateToProps = state => ({
  groupMap: state.faq.groupMap,
  expandedNodeIds: state.faq.expandedNodeIds
})

const mapDispatchToProps = dispatch => ({
  setFaqExpandedNodeIds: nodeIds => dispatch(setFaqExpandedNodeIds(nodeIds)),
  setFaqScrollToId: scrollToId => dispatch(setFaqScrollToId(scrollToId))
})

export default connect(mapStateToProps, mapDispatchToProps)(SmartFcFaqReferenceLink)
